




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Outlook extends Vue {
  @Prop({ default: '13' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly color?: string;
}
